import { createContext } from 'react';

import type { AxisIdToFormatter } from '../../types/xy-chart-internals.js';

export const XYChartAxesFormatterContext = createContext<
  AxisIdToFormatter | undefined
>(undefined);
